import React from 'react';
import Path from './Path';

const App = () => {
  return (
    <div>
      <Path />
    </div>
  );
};

export default App;